import { Complete, CompleteAndMissingInfo, CompleteAndNotEnrolled, MissingInfo, MissingInfoAndNotEnrolled } from '../../pages/arc/constants/constant-strings';
import { FilterOption } from '../search-model';

export const EmploymentTyes: FilterOption[] = [
	{
		filterKey: 'employmentType',
		filterDisplayValue: 'All Employment Types',
		filterValue: '',
	},
	{
		filterKey: 'employmentType',
		filterDisplayValue: 'Stipendiary',
		filterValue: 'Stipendiary',
	},
	{
		filterKey: 'employmentType',
		filterDisplayValue: 'Non-Stipendiary',
		filterValue: 'Non-Stipendiary',
	},
];

export const InformationStatus: FilterOption[] = [
	{
		filterKey: 'status_indicator',
		filterDisplayValue: CompleteAndMissingInfo,
		filterValue: '',
	},
	{
		filterKey: 'status_indicator',
		filterDisplayValue: Complete,
		filterValue: 'ok',
	},
	{
		filterKey: 'status_indicator',
		filterDisplayValue: MissingInfo,
		filterValue: 'missing_information',
	},
	{
		filterKey: 'status_indicator',
		filterDisplayValue: CompleteAndNotEnrolled,
		filterValue: 'ok_not_enrolled',
	},
	{
		filterKey: 'status_indicator',
		filterDisplayValue: MissingInfoAndNotEnrolled,
		filterValue: 'missing_information_not_enrolled',
	},
];

export const CleryAndLay: FilterOption[] = [
	{
		filterKey: 'status',
		filterDisplayValue: 'Both',
		filterValue: '',
	},
	{
		filterKey: 'status',
		filterDisplayValue: 'Clergy',
		filterValue: 'Active Clergy',
	},
	{
		filterKey: 'status',
		filterDisplayValue: 'Lay',
		filterValue: 'Lay',
	},
];